<ul class="list-unstyled payment-methods">
  <li>
    <img class="ls-is-cached" loading="lazy" alt="VISA" [src]="'assets/images/payment-methods/visa.svg' | staticFileHash" />
  </li>
  <li>
    <img
      class="ls-is-cached"
      loading="lazy"
      alt="AMEX"
      [src]="'assets/images/payment-methods/americanexpress.svg' | staticFileHash"
    />
  </li>
  <li>
    <img
      class="ls-is-cached"
      loading="lazy"
      alt="MASTERCARD"
      [src]="'assets/images/payment-methods/mastercard.svg' | staticFileHash"
    />
  </li>
  <li>
    <img class="ls-is-cached" loading="lazy" alt="PAYPAL" [src]="'assets/images/payment-methods/Paypal.svg' | staticFileHash" />
  </li>
  <li class="payment-terms paypal">
    <img class="ls-is-cached" loading="lazy" alt="PAYPAL" [src]="'assets/images/payment-methods/Paypal.svg' | staticFileHash" />
    <span>4X</span>
  </li>
  <li>
    <img class="ls-is-cached" loading="lazy" alt="GOOGLE PAY" [src]="'assets/images/payment-methods/GPay.svg' | staticFileHash" />
  </li>
  <li class="klarna">
    <img class="ls-is-cached" loading="lazy" alt="KLARNA" [src]="'assets/images/payment-methods/klarna.svg' | staticFileHash" />
  </li>
  <li class="payment-terms klarna">
    <img class="ls-is-cached" loading="lazy" alt="KLARNA" [src]="'assets/images/payment-methods/klarna.svg' | staticFileHash" />
    <span class="black-">3X</span>
  </li>
</ul>
